const headerData = [
    {
      prop: "id",
      label: "序号",
      columnwidth: 50,
    },
    {
      prop: "UserName",
      label: "用户名",
      columnwidth: 150,
    },
    {
      prop: "TrueName",
      label: "姓名",
      columnwidth: 150,
    },
    {
      prop: "CreateTime",
      label: "登录时间",
      columnwidth: 120,
    },
    {
      prop: "IsSuccessName",
      label: "是否成功登录",
      columnwidth: 150,
    },
    {
      prop: "IsLockName",
      label: "是否导致锁定",
      columnwidth: 150,
    },
    {
      prop: "ErrMessage",
      label: "登录失败原因",
      columnwidth: 591,
    }
  ]
  
  export default headerData;
  